export default function About() {
  return (
    <div>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint numquam maiores eveniet
      suscipit! Quaerat voluptate ut nihil possimus, repellendus assumenda explicabo veniam alias
      debitis autem tempora aspernatur qui neque aliquid!
    </div>
  );
}
